import { PropsWithChildren, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import Balancer from 'react-wrap-balancer';
import { FlowContainer } from '../assessment/shared';

export type PropTypes = PropsWithChildren<{
  title?: string;
  subtitle?: string;
  icon?: ReactNode;
}>;

const ErrorScreen = ({ title, subtitle, icon, children }: PropTypes) => (
  <FlowContainer>
    <Box sx={{ py: { xs: 2, sm: 3 } }}>
      {icon && <Box sx={{ mt: 2 }}>{icon}</Box>}
      <Balancer ratio={0.4}>
        <Typography variant="h4" component="h2" sx={{ mt: 3 }}>
          {title}
        </Typography>
      </Balancer>
      {subtitle && (
        <Typography variant="h6" component="h3" sx={{ mt: 3 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {children}
  </FlowContainer>
);

export default ErrorScreen;
